import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1701eebb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1701eebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701eebb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1701eebb')) {
      api.createRecord('1701eebb', component.options)
    } else {
      api.reload('1701eebb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1701eebb&scoped=true&", function () {
      api.rerender('1701eebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/mintage/index.vue"
export default component.exports